import React from "react";
import { Button } from "basis";

import { ERROR_TYPE } from "../../../../core/constants";

import { rejectSession, retryPayment } from "../../utils";

export const ActionPane = ({
  token,
  sessionID,
  gatewayName,
  cancelURL,
  allowRetry = false,
  onAction = () => {},
  onError = () => {},
}) => {
  const handleRetryPayment = async (e) => {
    e.preventDefault();
    onAction();

    const { response, success } = await retryPayment(
      token,
      gatewayName,
      sessionID
    );

    if (!success) {
      onError(ERROR_TYPE.INVALID_REQUEST);
      return;
    }

    window.location.replace(response.data.redirect_url);
    return;
  };

  const handleCancelOrder = async (e) => {
    e.preventDefault();
    onAction();

    //retry is not allowed. Session is rejected. redirect user to shopify
    if (!allowRetry) {
      window.location.replace(cancelURL);
      return;
    }

    // if retry is allowed, we have to reject the session and tell shopify
    const response = await rejectSession(token, sessionID, gatewayName);

    if (!response?.redirectUrl) {
      onError(response?.errorCode);
      return;
    }

    window.location.replace(response.redirectUrl);
    return;
  };

  return (
    <>
      {allowRetry && (
        <Button newTab={false} onClick={handleRetryPayment}>
          Retry payment
        </Button>
      )}

      <Button
        variant={allowRetry ? "secondary" : "primary"}
        onClick={handleCancelOrder}
      >
        Cancel order
      </Button>
    </>
  );
};
